<template>
  <div class="pd15 bg-white pie-box f-pr">
    <v-title :title="title" :tip-txt='tipTxt' />
    <no-data v-if="isNodata" height="350" />
    <div v-show="!isNodata" class="f-df f-ai f-jc">
      <slot></slot>
      <div
        :id="id"
        v-loading="isLoad"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        class="chart-box pie-chart"
      ></div>
      <dl class="pd-btm15 mg-left30 chart-legend-box">
        <dd
          v-for="(item, index) in pieList"
          :key="index"
          class="f-df f-ai f-jc mg-top10">
          <span :style="{background: item.color}" class="icon-pie-legend mg-right10"></span>
          <span :style="{'minWidth': pieLegendWidth}" class="color-gray-76 pd-right15">{{ item.name }}</span>
          <span class="color-dark f-tar" style="min-width: 60px;">{{ item.sum }} {{ item.unit || ''}}</span>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import vTitle from '@/components/vTitle.vue'
import noData from '@/components/nodata.vue'
import chartRender from '@/views/analysis/chartRender.js'
export default {
  components: {
    noData,
    vTitle
  },
  props: {
    isLoad: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    tipTxt: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    pieLegendWidth: {
      type: String,
      default: '80px'
    },
    pieList: {
      type: Array,
      default: () => ([])
    }
  },
  mixins: [chartRender],
  data() {
    return {
      isNodata: false
    }
  },
  watch: {
    pieList: {
      handler(newArr) {
        const seriesData = [{
          name: this.title,
          type: 'pie',
          data: []
        }]
        this.pieRender(this.id, 'sum', seriesData, this.pieList)
      },
      // immediate: true, // 首次也监听
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.pie-box{
  width: 35%;
  min-width: 400px;
  & .chart-box{
    height: 100%;
  }
  & .pie-chart{
    height: 350px;
    min-width: 200px;
  }
  & .chart-legend-box{
    min-width: 150px;
  }
  & .icon-pie-legend{
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
}
</style>
